
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <div className="flex items-center space-x-2 sm:space-x-3">
            <img 
              src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/7c15234fd7b4bba753ec95055981df06.png" 
              alt="ソーシャルパス" 
              className="h-8 sm:h-12 w-auto object-contain"
            />
            <img 
              src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/4f81a6a1fddabc0d5eca7ae9f00a260c.png" 
              alt="SOCIAL PATH" 
              className="h-10 sm:h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-purple-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
              ホーム
            </a>
            <a href="#solutions" className="text-gray-700 hover:text-purple-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
              ソリューション
            </a>
            <a href="#team" className="text-gray-700 hover:text-purple-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
              コアメンバー
            </a>
            <a href="#about" className="text-gray-700 hover:text-purple-600 font-medium transition-colors whitespace-nowrap cursor-pointer">
              会社概要
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-purple-600 cursor-pointer p-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-purple-100">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-gray-700 hover:text-purple-600 font-medium text-base cursor-pointer py-2">
                ホーム
              </a>
              <a href="#solutions" className="text-gray-700 hover:text-purple-600 font-medium text-base cursor-pointer py-2">
                ソリューション
              </a>
              <a href="#team" className="text-gray-700 hover:text-purple-600 font-medium text-base cursor-pointer py-2">
                コアメンバー
              </a>
              <a href="#about" className="text-gray-700 hover:text-purple-600 font-medium text-base cursor-pointer py-2">
                会社概要
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
